import React, { useState, useEffect } from 'react';

const icons = {
    check: 'M20 6L9 17l-5-5',
    x: 'M18 6L6 18M6 6l12 12',
    clock: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
    user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2 M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z'
};

const Icon = ({ d, size = 16, color = 'currentColor' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {d.split('M').filter(Boolean).map((path, i) => <path key={i} d={`M${path}`} />)}
    </svg>
);

export default function AdminUpdateRequests() {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchRequests();
    }, []);

    const fetchRequests = async () => {
        try {
            const res = await fetch('/api/plan-requests');
            const data = await res.json();
            setRequests(data);
        } catch (err) {
            console.error("Error fetching requests:", err);
        } finally {
            setLoading(false);
        }
    };

    const updateStatus = async (id, status) => {
        if (!window.confirm(`Are you sure you want to mark this request as ${status}?`)) return;
        try {
            const res = await fetch(`/api/plan-requests/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ status })
            });
            if (res.ok) {
                fetchRequests();
            } else {
                alert('Failed to update status');
            }
        } catch (err) {
            alert('Server error');
        }
    };

    const getStatusStyle = (status) => {
        switch (status) {
            case 'Approved': return { bg: '#dcfce7', text: '#166534', icon: icons.check, iconColor: '#16a34a' };
            case 'Rejected': return { bg: '#fee2e2', text: '#991b1b', icon: icons.x, iconColor: '#dc2626' };
            default: return { bg: '#fef3c7', text: '#92400e', icon: icons.clock, iconColor: '#d97706' };
        }
    };

    return (
        <div style={{ padding: '30px', background: '#f8fafc', minHeight: '100vh', fontFamily: 'Inter, sans-serif' }}>
            <div style={{ width: '100%' }}>
                <div className="superadmin-page-header">
                <div className="header-titles">
                    <h1>Plan Update Requests</h1>
                </div>
            </div>

                <div style={{ background: 'white', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr>
                                <th style={{ background: '#f8fafc', padding: '16px 24px', fontSize: '13px', fontWeight: '600', color: '#64748b', borderBottom: '1px solid #e2e8f0', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Operator</th>
                                <th style={{ background: '#f8fafc', padding: '16px 24px', fontSize: '13px', fontWeight: '600', color: '#64748b', borderBottom: '1px solid #e2e8f0', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Request Message</th>
                                <th style={{ background: '#f8fafc', padding: '16px 24px', fontSize: '13px', fontWeight: '600', color: '#64748b', borderBottom: '1px solid #e2e8f0', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Date Submitted</th>
                                <th style={{ background: '#f8fafc', padding: '16px 24px', fontSize: '13px', fontWeight: '600', color: '#64748b', borderBottom: '1px solid #e2e8f0', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Status</th>
                                <th style={{ background: '#f8fafc', padding: '16px 24px', fontSize: '13px', fontWeight: '600', color: '#64748b', borderBottom: '1px solid #e2e8f0', textTransform: 'uppercase', letterSpacing: '0.05em', textAlign: 'right' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="5" style={{ padding: '60px', textAlign: 'center', color: '#64748b' }}>Loading requests...</td>
                                </tr>
                            ) : requests.length === 0 ? (
                                <tr>
                                    <td colSpan="5" style={{ padding: '60px', textAlign: 'center', color: '#94a3b8' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                                            <Icon d={icons.check} size={40} color="#cbd5e1" />
                                            <span>No plan update requests found.</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                requests.map(req => {
                                    const statusStyle = getStatusStyle(req.status);
                                    return (
                                        <tr key={req._id} style={{ borderBottom: '1px solid #f1f5f9', transition: 'background 0.2s' }} onMouseEnter={e => e.currentTarget.style.background = '#fdfdff'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                                            <td style={{ padding: '20px 24px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <div style={{ width: '40px', height: '40px', background: '#e6f0fa', color: '#11427D', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <Icon d={icons.user} size={20} />
                                                    </div>
                                                    <span style={{ fontWeight: '600', color: '#1e293b', fontSize: '15px' }}>{req.operatorId?.companyName || 'Unknown Operator'}</span>
                                                </div>
                                            </td>
                                            <td style={{ padding: '20px 24px', maxWidth: '300px' }}>
                                                <p style={{ margin: 0, fontSize: '14px', color: '#475569', lineHeight: '1.5', wordBreak: 'break-word' }}>{req.message}</p>
                                            </td>
                                            <td style={{ padding: '20px 24px', fontSize: '14px', color: '#64748b', fontWeight: '500' }}>
                                                {new Date(req.createdAt).toLocaleString()}
                                            </td>
                                            <td style={{ padding: '20px 24px' }}>
                                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: statusStyle.bg, color: statusStyle.text, padding: '6px 12px', borderRadius: '99px', fontSize: '13px', fontWeight: '600' }}>
                                                    <Icon d={statusStyle.icon} size={14} color={statusStyle.iconColor} />
                                                    {req.status}
                                                </div>
                                            </td>
                                            <td style={{ padding: '20px 24px', textAlign: 'right' }}>
                                                {req.status === 'Pending' && (
                                                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                                                        <button onClick={() => updateStatus(req._id, 'Approved')} title="Approve Request" style={{
                                                            width: '36px', height: '36px', borderRadius: '8px', border: '1px solid #bbf7d0', background: '#f0fdf4', color: '#16a34a',
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'all 0.2s'
                                                        }}>
                                                            <Icon d={icons.check} size={18} />
                                                        </button>
                                                        <button onClick={() => updateStatus(req._id, 'Rejected')} title="Reject Request" style={{
                                                            width: '36px', height: '36px', borderRadius: '8px', border: '1px solid #fecaca', background: '#fef2f2', color: '#dc2626',
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'all 0.2s'
                                                        }}>
                                                            <Icon d={icons.x} size={18} />
                                                        </button>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
